module.exports = __webpack_public_path__ + "static/media/disabled-icon.a731a1de.svg";